import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ImageSliderPreviewOndermand = ({ images }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const settings = {
    dots: images.length > 1,
    infinite: images.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    afterChange: (current) => setCurrentSlide(current),
    customPaging: (index) => (
      <div
        className={`h-[5px] rounded-xl transition-all ${
          currentSlide === index ? "w-6 bg-amber-400" : "w-3.5 bg-stone-200"
        }`}
      />
    ),
    dotsClass: "slick-dots custom-dots",
  };

  if (images.length === 1) {
    const imageUrl = `${process.env.REACT_APP_URL_IMAGE}/${images[0]}`;
    const fileName = images[0].split("/").pop() || "Slide 1";

    return (
      <div className="flex flex-col">
        <div className="w-full">
          <img src={imageUrl} alt={fileName} className="w-full  object-cover" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <div className="w-full">
        <Slider {...settings}>
          {images.map((image, index) => {
            const imageUrl = `${process.env.REACT_APP_URL_IMAGE}/${image}`;
            const fileName = image.split("/").pop() || `Slide ${index + 1}`;

            return (
              <div key={index}>
                <img
                  src={imageUrl}
                  alt={fileName}
                  className="w-full  object-cover"
                />
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default ImageSliderPreviewOndermand;
